import b from 'b_';
import {
    InputChangeEvent,
    Radio,
    RadioGroup,
    RADIO_TYPES,
    useIntl,
    CONTROL_GROUP_ALIGNS,
    RADIO_SIZES,
    Text,
} from 'platform-components';
import { INPUT_SIZES } from 'platform-components/constants';
import React from 'react';

// @ts-ignore
import Input from 'common.components/form-view/__input/form-view__input.jsx';

import { CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE, CertificatesExpandedParamsModalFieldConfig } from '../typings';

import './certificates-expanded-params-modal__form-field.scss';

interface Props {
    errorMessage?: string | null;
    config: CertificatesExpandedParamsModalFieldConfig;
    onChangeValue: (event: InputChangeEvent) => void;
    onBlur: () => void;
    value: unknown;
}

const CertificatesExpandedParamsModalFormField = (props: Props) => {
    const { errorMessage, onChangeValue, onBlur, config, value } = props;
    const { infoType, inputType } = config;

    const intl = useIntl();

    if (inputType === CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.DATE) {
        return (
            <div className={b('certificates-expanded-params-modal__form-field', { type: inputType })}>
                <Input
                    errorMessage={errorMessage}
                    labelId={`certificatesExpandedParamsModal.formField.${infoType}.label`}
                    max={'9999-12-31'}
                    mix={b('certificates-expanded-params-modal__form-field-input', { type: inputType })}
                    onBlur={onBlur}
                    onChange={onChangeValue}
                    onFocus={onChangeValue}
                    size={INPUT_SIZES.L}
                    theme={Input.THEME.OUTLINED}
                    type={inputType}
                    valid={errorMessage ? 'no' : 'uncertain'}
                    value={value}
                />
            </div>
        );
    }

    if (inputType === CERTIFICATES_EXPANDED_FORM_FIELD_INPUT_TYPE.RADIO) {
        // @ts-ignore
        const { options } = config;

        return (
            <div className={b('certificates-expanded-params-modal__form-field', { type: inputType })}>
                <Text
                    className={b('certificates-expanded-params-modal__form-field-label', { type: inputType })}
                    id={`certificatesExpandedParamsModal.formField.${infoType}.label`}
                />
                <RadioGroup align={CONTROL_GROUP_ALIGNS.HORIZONTAL} type={RADIO_TYPES.TAB} value={value}>
                    {options?.choices.map((choice: string) => {
                        const choiceStr = intl.formatMessage({ id: choice });

                        return (
                            <Radio
                                mix={b('certificates-expanded-params-modal__form-field-input', { type: inputType })}
                                onBlur={onBlur}
                                onChange={onChangeValue}
                                onFocus={onChangeValue}
                                size={RADIO_SIZES.MEDIUM}
                                theme={Input.THEME.OUTLINED}
                                type={inputType}
                                valid={errorMessage ? 'no' : 'uncertain'}
                                value={choiceStr}
                            >
                                {choiceStr}
                            </Radio>
                        );
                    })}
                </RadioGroup>
                {errorMessage && (
                    <Text
                        className={b('certificates-expanded-params-modal__form-field-error-message', {
                            type: inputType,
                        })}
                        id={`certificatesExpandedParamsModal.formField.${infoType}.errorMessage.required`}
                        size={Text.SIZE.XS}
                    />
                )}
            </div>
        );
    }

    return (
        <div className={b('certificates-expanded-params-modal__form-field', { type: inputType })}>
            <Input
                errorMessage={errorMessage}
                labelId={`certificatesExpandedParamsModal.formField.${infoType}.label`}
                mix={b('certificates-expanded-params-modal__form-field-input', { type: inputType })}
                onBlur={onBlur}
                onChange={onChangeValue}
                onFocus={onChangeValue}
                placeholder={intl.formatMessage({
                    id: `certificatesExpandedParamsModal.formField.${infoType}.placeholder`,
                })}
                size={INPUT_SIZES.L}
                theme={Input.THEME.OUTLINED}
                type={inputType}
                valid={errorMessage ? 'no' : 'uncertain'}
                value={value}
            />
        </div>
    );
};

export default CertificatesExpandedParamsModalFormField;
